const getProcessorTargetVariables = target => (target ? { target } : {});

export default getProcessorTargetVariables;
